let uid = 0

export default {
    name: "SchemaMarkupNumber",

    props: {
        modelValue: { type: [Number, String], default: "" },
        label: { type: String, default: "" },
        readonly: { type: Boolean, default: false }
    },

    emits: ["update:modelValue"],

    setup(props, { emit }) {
        const fieldId = `kb-number-${++uid}`
        const onInput = (event) => {
            const raw = event.target.value
            emit("update:modelValue", raw === "" ? "" : Number(raw))
        }
        return { fieldId, onInput }
    }
}
